import { GeocoderService } from './geocoder-service';
import { PlaceService } from './places-service';

export const geocoder = new GeocoderService();
export const places = new PlaceService();
